// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__rwHXJ","headerWrapper":"style_headerWrapper__Xkwgv","title":"style_title__FLBGl","img":"style_img__Jbkrq"};